import { SalesOrderStatus } from '../constants/sales-order-status.js';
// WHY: SHIPPED is the live open-AR status, and the as-of rule in load-ar-open-items.ts adds COMPLETE orders closed after T.
export const AR_COUNTABLE_SALES_ORDER_STATUSES = [SalesOrderStatus.SHIPPED];
//# sourceMappingURL=ar-countable-sales-order-statuses.js.map